import { Injectable } from "@nestjs/common";
import { Assets } from "../../open-assets/open-assets-entity";
import { AssetLocationMappingDto } from "../dto/asset-location-mapping.dto";
import { AssetLocationTransactionDto } from "../dto/asset-location-transaction.dto";
import { AssetLocationMapping } from "./asset-location-mapping.entity";
import { AssetLocationTransaction } from "./asset-location-transaction.entity";

@Injectable()
export class AssetLocationMappingAdapter {
    public convertDtoToAssetLocationMappingEntity(assetLocationMappingDto : AssetLocationMappingDto, isUpdate: boolean = false ) : AssetLocationMapping[] {
        const assetLocationMappingArr:AssetLocationMapping[]= []
        for(const assetId of assetLocationMappingDto.assetId){
            const assetLocationMapping = new AssetLocationMapping();
            assetLocationMapping.assetsId = new Assets();
            assetLocationMapping.assetsId.assetId = assetId ;
            assetLocationMapping.locationId = assetLocationMappingDto.locationId;
            // assetLocationMapping.location = assetLocationMappingDto.location;
            assetLocationMapping.isActive = assetLocationMappingDto.isActive == undefined ? true : assetLocationMappingDto.isActive;
            assetLocationMappingArr.push(assetLocationMapping)
        }

        return assetLocationMappingArr;
    }

    public convertDtoToAssetLocationTransactionEnitity(assetLocationTransDto : AssetLocationTransactionDto, isUpdate: boolean = false) : AssetLocationTransaction {
        const assetLocationTrans = new AssetLocationTransaction();
        assetLocationTrans.assetLocationTransactionId = assetLocationTransDto.assetLocationTransactionId;
        assetLocationTrans.assetLocationMapping = new AssetLocationMapping ;
        assetLocationTrans.assetLocationMapping.assetLocationId = assetLocationTransDto.assetLocationId;
        assetLocationTrans.assetId = assetLocationTransDto.assetId;
        assetLocationTrans.locationId = assetLocationTransDto.locationId;
        assetLocationTrans.isActive = assetLocationTransDto.isActive == undefined ? true : assetLocationTransDto.isActive;
        assetLocationTrans.status = assetLocationTransDto.status;

        return assetLocationTrans;
    } 
}

